import { logger } from '@damofire/data-commons';
import { Remote, wrap } from 'comlink';
import { Observer, Subject } from 'rxjs';
import { WarehouseSyncStepContextEvent, WarehouseSyncStepTask, WarehouseSyncStepTaskContext } from '../executors';
import { WarehouseSavedSearchesStepsWorker } from '../workers/saved-searches.steps.worker';
import { executeWorker, WarehouseSyncStepWorkerFactory } from './steps-utils';

class WarehouseSavedSearchesSyncWorkerFactory implements WarehouseSyncStepWorkerFactory<WarehouseSavedSearchesStepsWorker> {
  async createWorker(environment: any): Promise<[Worker, WarehouseSavedSearchesStepsWorker | Remote<WarehouseSavedSearchesStepsWorker>]> {
    if (environment.appConfig.watson.useWebworkers) {
      const warehouseWorker = new Worker(new URL('../workers/saved-searches.steps.worker', import.meta.url), { type: 'module' });
      const warehouseWorkerProxy = wrap<typeof WarehouseSavedSearchesStepsWorker>(warehouseWorker);
      const workerService = await new warehouseWorkerProxy();
      return [warehouseWorker, workerService];
    }

    return [null, new WarehouseSavedSearchesStepsWorker()];
  }
}

export class WarehousePushSavedSearchesSyncStepTask implements WarehouseSyncStepTask {
  constructor(private readonly environment: any) {}

  name(): string {
    return `PUSH_SSS_TASK`;
  }

  async execute(ctx: WarehouseSyncStepTaskContext, listener: Observer<WarehouseSyncStepContextEvent>, taskBreaker: Subject<boolean>): Promise<void> {
    logger.debug('Executing push savedSearches sync task.');
    await executeWorker(ctx, this.environment, listener, new WarehouseSavedSearchesSyncWorkerFactory(), taskBreaker);
  }
}

export class WarehouseDownloadSavedSearchesSyncStepTask implements WarehouseSyncStepTask {
  constructor(private readonly environment: any) {}

  name(): string {
    return `DOWN_SSS_TASK`;
  }

  async execute(ctx: WarehouseSyncStepTaskContext, listener: Observer<WarehouseSyncStepContextEvent>, taskBreaker: Subject<boolean>): Promise<void> {
    logger.debug('Executing download savedSearches sync task.');
    await executeWorker(ctx, this.environment, listener, new WarehouseSavedSearchesSyncWorkerFactory(), taskBreaker);
  }
}

export class WarehouseCleanSavedSearchesSyncStepTask implements WarehouseSyncStepTask {
  constructor(private readonly environment: any) {}

  name(): string {
    return `CLEAN_SSS_TASK`;
  }

  async execute(ctx: WarehouseSyncStepTaskContext, listener: Observer<WarehouseSyncStepContextEvent>, taskBreaker: Subject<boolean>): Promise<void> {
    logger.debug('Executing clean savedSearches sync task.');
    await executeWorker(ctx, this.environment, listener, new WarehouseSavedSearchesSyncWorkerFactory(), taskBreaker);
  }
}
